import Vue from "vue";

Vue.prototype.$goToLivePage = function (course_type, course_id, period) {
  const { href } = this.$router.resolve({
    name: "Live",
    query: {
      course_type: course_type,
      course_id: course_id,
      period_id: period.id,
      title: encodeURIComponent(period.title),
      bjy_period_id: period.period_id,
      type: period.type,
      meeting_id: period.meeting_id,
    },
  });
  if (this.$store.state.commonSetting.is_live_new_tag == 1) {
    window.open(href);
  } else {
    document.location = href;
  }
};

/**
 * 进入直播间
 * @param {String|Number} course_id 课程id
 * @param {String|Number} course_type 课程类型
 * @param {String|Number} period_id 学时id，公开课为0，一对一省略
 * @returns {void}
 */
Vue.prototype.$livePlay = async function (course_id, course_type, period) {
  const buildConfig = require("../../build/" + process.env.BUILD_ENV + ".js");
  localStorage.setItem("API_BASE", buildConfig.BASE_URL);
  let liveData;

  if (course_type == 1) {
    liveData = await this.$http.get(
      "/api/app/oto/getLiveRoomCode/" + course_id + "/0",
      {},
      {
        isAuthRequest: true,
      },
    );
  } else if (
    course_type == 2 ||
    course_type == 3 ||
    course_type == 4 ||
    course_type == 15
  ) {
    let params = { type: period.type };
    if (period.parent) {
      params.system_course_id = period.parent;
    }
    if (course_type == 4) {
      params.repeat_times = 1;
    }

    let data = await this.$http.get(
      "/api/app/getPcRoomCode/course_id=" +
        course_id +
        "/chapter_id=" +
        period.id,
      params,
      {
        isAuthRequest: true,
      },
    );
    liveData = data.chapterInfo;

  } else if (course_type == "meeting") {
    //班会
    let params = {};
    params.type = period.type;
    params.meeting_id = period.meeting_id;
    let data = await this.$http.get(
      "/api/app/getPcRoomCode/course_id=" +
        course_id +
        "/chapter_id=" +
        period.id,
      params,
      {
        isAuthRequest: true,
      },
    );
    liveData = data;
  } else {
    return;
  }
  if (liveData) {
    if (this.$store.state.commonSetting.client_download_on == 0) {
      this.$goToLivePage(course_type, course_id, period);
    } else if (this.$store.state.commonSetting.client_download_on == 1) {
      if (liveData.client_url) {
        const { href } = this.$router.resolve({
          name: "DownloadClient",
          query: {
            url: liveData.client_url,
          },
        });
        document.location = href;
      } else {
        this.$goToLivePage(course_type, course_id, period);
      }
    } else if (this.$store.state.commonSetting.client_download_on == 2) {
      if (liveData.client_url) {
        this.$courseExtension.openLiveSelect({
          webHandler: () => {
            this.$goToLivePage(course_type, course_id, period);
          },
          clientHandler: () => {
            this.$services.LiveService.openClient(liveData.client_url);
          },
        });
      } else {
        this.$goToLivePage(course_type, course_id, period);
      }
    }
  }
};
